import { createSlice } from "@reduxjs/toolkit";

const additionalInfoSlice = createSlice({
  name: "additionalInfo",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    setAthleteAdditionalData: (state, action) => {
      state.data = action.payload;
    },
    setLoadingAthleteAdditional: (state, action) => {
      state.loading = action.payload;
    },
    setErrorAthleteAdditional: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setAthleteAdditionalData,
  setLoadingAthleteAdditional,
  setErrorAthleteAdditional,
} = additionalInfoSlice.actions;

export default additionalInfoSlice.reducer;
